<template>
    <app-layout title="Aanvragen">
        <template #header>
            <page-title title="Nieuwe aanvraag" />
        </template>

        <template #pageContent>
            <Add
                :requestTypes="requestTypes"
                :estimates="estimates"
                :modalOpen="true"
            />
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'

import Add from '@/Components/Requests/Add.vue'

export default {
    components: {
        AppLayout,
        PageTitle,
        Add,
    },
    props: [
        'requestTypes',
        'estimates',
    ],
    setup (props){

    },
}

</script>
